<template>
  <div>
    <popup-hint hint="shipments">
      <template v-slot:breadcrumbs>
        <breadcrumbs home="Shipments">
          <template v-slot:left v-if="salesStatus.toDeliver+salesStatus.draftShipments">
            <list-notification v-model="showStatus">
              <v-list-item v-if="salesStatus.draftShipments">
                <v-icon>mdi-arrow-right-thin</v-icon>
                {{salesStatus.draftShipments}} draft shipment{{salesStatus.draftShipments===1?'':'s'}}
                <v-spacer/>
                <v-btn small color="warning" @click="showStatus=false;$nextTick(() => {filters.from=null;filters.to=null;filters.customerId=null;filters.customerName=null;filters.search=null;filters.salesOrderId=null;filters.delivered='2';filters.draft='1'})">View</v-btn>
              </v-list-item>
              <v-list-item v-if="salesStatus.toDeliver">
                <v-icon>mdi-arrow-right-thin</v-icon>
                {{salesStatus.toDeliver}} shipment{{salesStatus.toDeliver===1?'':'s'}} to deliver
                <v-spacer/>
                <v-btn small color="warning" @click="showStatus=false;$nextTick(() => {filters.from=null;filters.to=null;filters.customerId=null;filters.search=null;filters.salesOrderId=null;filters.draft='0';filters.delivered='0'})">View</v-btn>
              </v-list-item>
            </list-notification>
          </template>
          <template v-slot:right>
            <v-menu offset-y v-if="company.permissions.includes('config.write')" :close-on-content-click="false" nudge-bottom="5" left>
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">mdi-tune-variant</v-icon>
              </template>
              <v-card width="400">
                <sales-preferences/>
              </v-card>
            </v-menu>
          </template>
        </breadcrumbs>
      </template>
      <template v-slot:top>
        Shipments are used to handle inventory leaving the distillery to a customer.
      </template>
    </popup-hint>

    <purtrak-table name="shipments" objectType="shipments" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-select show-expand
                   listEndPoint="shipments2" v-model="selected"
                   fields="id,date,draft,customer{id,name},privateNote,delivered,number,site{name},invoice {id,total,number,type,salesRepId,paid,discount{percent,amount,value}},attachmentURL,shipmentZone{id,name},transactionId"
                   :listFilters="listFilters"
                   :item-class="shipment => (shipment.draft ? 'grey--text ' : '')"
                   @dblclick="shipment => $router.push({name:'SalesShipmentsEdit',params:{shipmentId:shipment.id}})"
                   @itemExpanded="({item, value}) => expand(item, value)"
                   title="Shipments"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.from?dateDisplay:'',
                                            filters.search?searchDisplay:'',
                                            filters.draft==='1'?'Draft':'',
                                            filters.delivered==='1'?'Delivered':'',
                                            filters.delivered==='0'?'Undelivered':'',
                                            filters.shipmentZoneId!=null?shipmentZoneName:'']}"
                   download-endpoint="shipmentExportCSV">

      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.draft='0';filters.delivered='2';filters.from=null;filters.to=null;filters.search='';filters.customerId=null;filters.shipmentZoneId=null">
          <v-list-item>
            <filter-search :label="[{text:'Name',value:'customerName'},{text:'Ref #',value:'number'},{text:'Transaction ID',value:'transactionId'}]" v-model="filters.search" :search-field.sync="filters.searchField" :search-display.sync="searchDisplay"/>
          </v-list-item>
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item>
            <shipment-zones-select v-model="filters.shipmentZoneId" label="Shipment zone" :name.sync="shipmentZoneName" none-text="All"/>
          </v-list-item>
          <v-list-item>
            <v-select label="Delivered" outlined dense hide-details v-model="filters.delivered"
                      :items="[{text:'Any',value:'2'},{divider:true},{text:'Delivered',value:'1'},{text:'Undelivered',value:'0'}]"/>
          </v-list-item>
          <v-list-item dense>
            <v-checkbox v-model="filters.draft" true-value="1" false-value="0" label="Show draft only"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.search" close small class="ml-1" @click:close="filters.search='';filters.customerId=null">{{searchDisplay}}</v-chip>
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.draft=='1'" close small class="ml-1" @click:close="filters.draft='0'">Draft only</v-chip>
          <v-chip v-show="filters.delivered!=='2'" close small class="ml-1" @click:close="filters.delivered='2'">
            {{filters.delivered==='0'?'Und':'D'}}elivered
          </v-chip>
          <v-chip v-show="filters.salesOrderNumber" close small class="ml-1" @click:close="filters.salesOrderId=null;filters.salesOrderNumber=null">Sales order {{filters.salesOrderNumber}}</v-chip>
          <v-chip v-show="filters.shipmentZoneId!=null" close small class="ml-1" @click:close="filters.shipmentZoneId=null">{{shipmentZoneName}}</v-chip>
        </template>
      </template>
      <template v-slot:menu>
        <template v-if="!readOnly">
          <v-list-item :to="{name:'SalesShipmentsEditNew'}"><v-list-item-title>Create shipment</v-list-item-title></v-list-item>
          <v-divider/>
        </template>
        <template v-if="company.allowRecurringTransactions">
          <v-list-item :to="{name:'RecurringTransactions',query:{targetType:'Shipment'}}"><v-list-item-title>Recurring shipments</v-list-item-title></v-list-item>
          <v-divider/>
        </template>

        <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Shipments',to:{name:'SalesShipments'}}]},query:{to:'reports/sales/ReportsSalesUndelivered'}}"><v-list-item-title>Undelivered shipments report</v-list-item-title></v-list-item>

        <template v-if="!$vuetify.breakpoint.mobile">
          <v-divider/>
          <v-list-item @click="doImport=true"><v-list-item-title>Import shipments from CSV</v-list-item-title></v-list-item>
        </template>
      </template>

      <template v-slot:footer v-if="selected.length">
        <v-icon style="position: absolute" class="mt-3 ml-3">mdi-arrow-up-left</v-icon>
        <v-menu offset-y top>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch commands</v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="deliverMultiple(true)"><v-list-item-title>Deliver</v-list-item-title></v-list-item>
            <v-list-item @click="deliverMultiple(false)"><v-list-item-title>Undeliver</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item @click="print('SalesShipmentsPrintDeliveryNote')"><v-list-item-title>Print delivery note</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item @click="deleteMultiple=true;showDelete=true"><v-list-item-title>Delete</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.date="{item,printing}">
        {{item.date | formatDateTime}}
        <div v-if="!printing && item.draft" class="caption black--text">Draft</div>
      </template>
      <template v-slot:item.customerName="{item,printing}">
        {{item.customer.name}}
        <div v-if="!printing" class="text-caption">{{item.privateNote}}</div>
      </template>
      <template v-slot:item.invoice="{item,printing}">
        <template v-if="!!item.invoice">
          <template v-if="printing">{{invoiceInfo(item)}}</template>
          <template v-else>
            <v-hover v-slot="{hover}">
              <a @click.stop="$router.push({name:'SalesInvoicesEdit',params:{invoiceId:item.invoice.id}})"
                :class="{'text-decoration-underline':hover}">{{invoiceInfo(item)}}</a>
            </v-hover>
            <div v-if="item.invoice.paid" class="green--text">PAID</div>
          </template>
        </template>
      </template>
      <template v-slot:item.draft="{value,printing}">
        <template v-if="printing">{{value?'Y':''}}</template>
        <v-icon v-else-if="value">mdi-check</v-icon>
      </template>
      <template v-slot:item.delivered="{value,printing,item}">
        <template v-if="printing">{{value?'Y':''}}</template>
        <v-icon v-else-if="value">mdi-check</v-icon>
        <div v-if="!printing && !value && !readOnly && !item.draft">
          <v-btn rounded color="warning lighten-1" x-small @click="deliver(item,true)">DELIVER</v-btn>
        </div>
      </template>
      <template v-slot:item.shipmentZoneName="{item}">
        {{item.shipmentZone ? item.shipmentZone.name : ''}}
      </template>
      <template v-slot:header.attachmentURL>
        <v-icon>mdi-paperclip</v-icon>
      </template>
      <template v-slot:item.attachmentURL="{value}">
        <v-icon v-if="value" class="green--text" @click="open(value)">mdi-paperclip</v-icon>
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'SalesShipmentsEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="200" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Shipment operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <template>
              <template v-if="!readOnly && !item.draft">
                <v-list-item @click="deliver(item, !item.delivered)"><v-list-item-title>{{item.delivered?'Und':'D'}}eliver</v-list-item-title></v-list-item>
                <v-list-item v-if="!item.invoice" :to="{name:'SalesInvoicesEditNew',params:{shipmentId:item.id}}"><v-list-item-title>Create invoice</v-list-item-title></v-list-item>
                <v-list-item :to="{name:'SalesReturnsEditNew',params:{shipmentId:item.id}}"><v-list-item-title>Create return</v-list-item-title></v-list-item>
                <v-divider/>
              </template>
              <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Shipments',to:{name:'SalesShipments'}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:'',forward:1}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
              <v-list-item v-if="company.allowAudit && company.permissions.includes('audit')" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
              <v-divider/>
              <v-menu :nudge-left="210">
                <template v-slot:activator="{on:print}">
                  <v-list-item v-on="print">
                    <v-list-item-title>Print</v-list-item-title>
                    <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
                  </v-list-item>
                </template>
                <v-list dense>
                  <v-list-item @click="print('SalesShipmentsPrintPackingList', item)"><v-list-item-title>Print packing list</v-list-item-title></v-list-item>
                  <v-list-item @click="print('SalesShipmentsPrintBOL', item)"><v-list-item-title>Print bill of lading / B60</v-list-item-title></v-list-item>
                  <v-list-item @click="print('SalesShipmentsPrintDeliveryNote', item)"><v-list-item-title>Print delivery note</v-list-item-title></v-list-item>
                  <v-divider/>
                  <v-list-item @click="print('SalesShipmentsPrintPickList', item)"><v-list-item-title>Print pick list</v-list-item-title></v-list-item>

<!--
    <v-list-item :to="{name:'SalesShipmentsDeliveryNote', params:{shipmentId:item.id}}"><v-list-item-title>TEST delivery note</v-list-item-title></v-list-item>
    -->
                </v-list>
              </v-menu>
              <v-divider/>
              <v-list-item :to="{name:'SalesShipmentsEdit',params:{shipmentId:item.id}}"><v-list-item-title>Edit shipment</v-list-item-title></v-list-item>
              <v-list-item :to="{name:'SalesShipmentsEditNew',params:{copyShipmentId:item.id}}"><v-list-item-title>Copy shipment</v-list-item-title></v-list-item>
              <v-list-item @click="updatePrivateNote(item)"><v-list-item-title>Update private note</v-list-item-title></v-list-item>
              <v-list-item @click="shipment=item;deleteMultiple=false;showDelete=true"><v-list-item-title>Delete shipment</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:expanded-item="{ headers,item }">
        <td :colspan="headers.length">
          <v-card class="my-4" :class="expansionPanelClass">
          <v-simple-table dense class="pl-4 text-caption" :class="expansionPanelClass" :style="values && item.invoice ? 'width:90%' : 'width:70%'">
            <thead>
              <tr>
                <th :class="expansionPanelClass" width="40%">Description</th>
                <th :class="expansionPanelClass" width="12%">Lot</th>
                <th :class="expansionPanelClass" width="12%">SO #</th>
                <th class="text-right" :class="expansionPanelClass" width="15%">Quantity</th>
                <th class="text-right" :class="expansionPanelClass" width="10%" v-if="values && item.invoice">Unit price</th>
                <th class="text-right" :class="expansionPanelClass" width="11%" v-if="values && item.invoice">Amount</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="line of item.lines">
                <tr :key="line.key">
                  <td class="text-caption">{{line.description}}</td>
                  <td class="text-caption">
                    <a @click="$router.push({name:'ReportsView',params:{back:[{text:'Shipments',to:{name:'SalesShipments'}}]},query:{to:'reports/inventory/ReportsLot',id:line.id,lot:line.lot,forward:0}})">{{line.lot}}</a>
                  </td>
                  <td class="text-caption">
                    <a @click="$router.push({name:'SalesSalesOrdersEdit',params:{salesOrderId:line.salesOrderId}})">
                      {{line.salesOrderNumber}}
                    </a>
                  </td>
                  <td class="text-caption text-right">{{line.quantity | number(line.precision)}} {{line.units}}</td>
                  <template v-if="!line.items">
                    <td class="text-caption text-right" v-if="values && item.invoice">${{line.unitPrice | number(4)}}</td>
                    <td class="text-caption text-right" v-if="values && item.invoice">{{line.amount | currency}}</td>
                  </template>
                  <td v-else colspan="2"/>
                </tr>
                <tr v-for="bundlineLine of line.items" :key="bundlineLine.key">
                  <td class="text-caption"><span class="ml-4">{{bundlineLine.description}}</span></td>
                  <td class="text-caption">
                    <a @click="$router.push({name:'ReportsView',params:{back:[{text:'Shipments',to:{name:'SalesShipments'}}]},query:{to:'reports/inventory/ReportsLot',id:bundlineLine.id,lot:bundlineLine.lot,forward:0}})">{{bundlineLine.lot}}</a>
                  </td>
                  <td class="text-caption">
                    <a @click="$router.push({name:'SalesSalesOrdersEdit',params:{salesOrderId:bundlineLine.salesOrderId}})">
                      {{bundlineLine.salesOrderNumber}}
                    </a>
                  </td>
                  <td class="text-caption text-right">{{line.quantity}}x{{bundlineLine.quantity | number(bundlineLine.precision)}} {{bundlineLine.units}}</td>
                  <td class="text-caption text-right" v-if="values && item.invoice">${{bundlineLine.unitPrice | number(4)}}</td>
                  <td class="text-caption text-right" v-if="values && item.invoice">{{bundlineLine.amount | currency}}</td>
                </tr>
              </template>
              <tr v-if="item.invoice && item.invoice.discount.amount">
                <td class="text-caption text-right" colspan="5">Discount
                  <template v-if="item.invoice.discount.percent">{{item.invoice.discount.amount | number(2)}}%</template>
                  <template v-else>{{item.invoice.discount.amount | currency}}</template>
                </td>
                <td class="text-caption text-right">- {{item.invoice.discount.value | currency}}</td>
              </tr>
              <template v-for="tax of item.taxLines">
                <tr :key="tax.id">
                  <td class="text-caption text-right" colspan="5">
                    {{tax.name}} @ {{tax.percent}}% on {{tax.onAmount | currency}}
                  </td>
                  <td class="text-caption text-right">{{tax.amount | currency}}</td>
                </tr>
              </template>
            </tbody>
          </v-simple-table>
          </v-card>
        </td>
      </template>
    </purtrak-table>

    <import-csv v-model="doImport" type="shipments"
              :fields="[{name:'Transaction',mapTo:'',mandatory:false},
                        {name:'Date',mapTo:'',mandatory:false,date:true},
                        {name:'Customer',mapTo:'',mandatory:false},
                        {name:'Invoice type',mapTo:'',mandatory:false},
                        {name:'Item id',mapTo:'',mandatory:true},
                        {name:'In-bond',mapTo:'',mandatory:false},
                        {name:'Description',mapTo:'',mandatory:false},
                        {name:'SKU',mapTo:'',mandatory:false},
                        {name:'Site',mapTo:'',mandatory:false},
                        {name:'Lot',mapTo:'',mandatory:false},
                        {name:'Quantity',mapTo:'',mandatory:true},
                        {name:'Cases',mapTo:'',mandatory:false},
                        {name:'Amount',mapTo:'',mandatory:true},
                        {name:'Tax',mapTo:'',mandatory:false},
                        {name:'Note',mapTo:'',mandatory:false},
                        {name:'Invoice number',mapTo:'',mandatory:false}
                        ]"
              importAction="shipmentsImport" :instructions="instructions" :defaults="salesShipmentsImport" @refresh="$refs.table.buildList()"/>

    <component :is="dialog" v-bind="dialogProperties" :shipment="shipment" :shipments="selected" @done="dialog = null"/>
    <delete-object v-model="showDelete" :name="deleteMultiple?'ALL selected shipments and associated invoices':`this shipment${shipment&&shipment.invoice&&shipment.invoice.id?' and associated invoice':''}`" @delete="performDelete(shipment.id)"/>
  </div>
</template>

<script>
import performDelete from '@/mixins/performDelete'
import SalesPreferences from '@/views/sales/SalesPreferences'
import ShipmentZonesSelect from '@/views/sales/shipmentZones/SalesShipmentZonesSelect'

export default {
  name: 'SalesShipments',
  mixins: [performDelete],
  components: {SalesPreferences,ShipmentZonesSelect},
  data() {
    return {
      filters: {
        search: '',
        searchField: 'customerName',
        draft: '0',
        delivered: '2',
        from: null,
        to: null,
        customerId: null,
        customerName: null,
        salesOrderId: null,
        salesOrderNumber: null,
        shipmentZoneId: null
      },
      salesStatus: {},
      showStatus: false,
      shipmentZoneName: '',
      dateDisplay: '',
      searchDisplay: '',
      shipment: {},
//      salesReps: [],
      showDelete: false,
      deleteMultiple: false,
      doImport: false,
			dialog: null,
      dialogProperties: {},
      instructions: `<ol class="mb-4">
                      <li>Transaction identifier (optional)</li>
                      <li>Date (optional)</li>
                      <li>Customer id or name (optional)</li>
                      <li>Invoice type, e.g. None, Invoice, Cash, Cheque, Credit Card, Direct Debit (optional)</li>
                      <li>Item id (either SKU or UPC of product, item or bundle for matching)</li>
                      <li>In-bond, i.e. product comes from in-bond inventory vs. duty-paid (optional, defaulting to false and only used for products)</li>
                      <li>Description (optional)</li>
                      <li>SKU (optional)</li>
                      <li>Site (optional)</li>
                      <li>Lot (not required if lot tracking disabled)</li>
                      <li>Quantity</li>
                      <li>Cases, if quantity for products are cases not bottles/units (optional, default is false)</li>
                      <li>Amount</li>
                      <li>Tax (optional)</li>
                      <li>Note (optional)</li>
                      <li>Invoice number (optional)</li>
                      </ol>
                      <em>Note that not all information for a shipment can be imported.</em>
                      You should, therefore, check each imported shipment to ensure all settings are correct.
                      <div class="mt-4"><em>Only products and items & services can be imported.</em></div>
                      <div class="mt-4">A separate shipment is created for each unique transaction/date/customer in the
                      list of shipment items to be imported. Most optional information can be specified as
                      default values to use for all items.</div>
                      `,
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'number', visible:true},
                       { value: 'customerName', visible:true},
                       { value: 'invoice', visible:true},
                       { value: 'delivered', visible:true},
                       { value: 'attachmentURL', visible:true,excludeFromExport:true},
                       { value: 'draft', visible:false},
                       { value: 'shipVia', visible:false},
                       { value: 'shipmentZoneName', visible:false},
                       { value: 'site.name', visible:false},
                       { value: 'privateNote', visible:false},
                       { value: 'transactionId', visible:false}],
      headers: [{ text: 'DATE', value: 'date', width:'15%',sortable:true},
                { text: 'REF #', value: 'number' ,width:'15%',sortable:true},
                { text: 'CUSTOMER', value: 'customerName' ,width:'40%',sortable:true},
                { text: 'NOTE', value: 'privateNote' ,width:'40%',sortable:false},
                { text: 'SHIP', value: 'shipVia' ,width:'15%',sortable:true},
                { text: 'ZONE', value: 'shipmentZoneName', width:'10%',sortable:true},
                { text: 'INVOICE', value: 'invoice' ,width:'30%',sortable:false},
                { text: 'DELIVERED', value: 'delivered' ,width:'10%',sortable:true,align:'center'},
                { text: 'SITE', value: 'site.name' ,width:'20%',sortable:true,omit:() => this.sites.length <= 1},
                { text: 'ATTACHMENT', value: 'attachmentURL' ,width:'5%',sortable:false,print:false},
                { text: 'DRAFT?', value: 'draft' ,width:'10%',sortable:true,align:'center'},
                { text: 'TRANSACTION ID', value: 'transactionId' ,width:'10%',sortable:false,align:'left'}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    sites() {
      return this.$store.getters.sites(true);
    },
    homeCurrency() {
      return this.company.settings.homeCurrency;
    },
    readOnly() {
      return !this.company.permissions.includes('selling.write');
    },
    values() {
      return this.company.permissions.includes('values');
    },
    salesShipmentsImport() {
      return () => import('@/views/sales/shipments/SalesShipmentsImport');
    },
    listFilters() {
//      if (!this.salesReps)   // Prevent showing anything until sales rep info (in create) is fetched, since refresh may come first
//        return;

      const filters = [];
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.salesOrderId)
        filters.push({field:'salesOrderId', comparator:'eq', value:this.filters.salesOrderId});
      if (this.filters.customerId !== null)
        filters.push({field:'customerId', comparator:'eq', value:this.filters.customerId});
      if (this.filters.draft == '1')
        filters.push({field:'draft', comparator:'eq', value:'true'});
      if (this.filters.delivered == '1' || this.filters.delivered == '0')
        filters.push({field:'delivered', comparator:'eq', value:this.filters.delivered == '1' ? 'true' : 'false'});
      if (this.filters.search)
        filters.push({field:this.filters.searchField, comparator:'contains', value:this.filters.search});
      if (this.filters.shipmentZoneId)
        filters.push({field:'shipmentZoneId', comparator:'eq', value:this.filters.shipmentZoneId});
      return filters;
    }
  },
  async created() {
    this.$store.dispatch('checkTasks');
//    this.$lazyListLoad(this.salesReps, 'salesReps2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);

    await this.getStatus();
    if (!['SalesShipmentsEdit', 'SalesShipmentsEditNew','ReportsView','SalesInvoicesEditNew'].includes(this._previousRoute) &&
        Object.keys(this.$route.query).length === 0 &&
        (this.salesStatus.draftShipments + this.salesStatus.toDeliver) && !localStorage.getItem('hideNotification')) {
      this.$nextTick(() => this.showStatus = true);
      setTimeout(() => this.showStatus = false, 10_000);  // Close in 10 seconds
    }
  },
  methods: {
    invoiceInfo({invoice}) {
      return `${invoice.type} ${invoice.number} ${this.$currency(invoice.total)}`;
    },
    async expand(item, value) {
      if (value && !item.lines) {
        this.loading = true;
        const results = await this.$apiCall(`query SalesShipments($id:ID!) {
                                                shipment(id:$id) {
                                                  lines {
                                                    description,quantity,units,precision,unitPrice,amount,lot,id,salesOrderNumber,salesOrderId
                                                    items {description,quantity,units,precision,unitPrice,amount,lot,id,salesOrderNumber,salesOrderId}
                                                  }
                                                  taxLines {id,name,amount,onAmount,percent}
                                                }
                                              }`,
                                            {id:item.id});
        this.$set(item, 'lines', results.data.shipment.lines);
        this.$set(item, 'taxLines', this.values && item.invoice ? results.data.shipment.taxLines : []);
        let key = 1;
        item.lines.forEach(line => line.key = key++);
        this.loading = false;
      }
    },
    async getStatus() {
      this.loading = true;
      const results = await this.$apiCall(`query SalesShipments {
                                                salesStatus {
                                                  draftShipments,toDeliver
                                                }
                                              }`);
      if (!results.error)
        this.salesStatus = results.data.salesStatus;
      this.loading = false;
    },
    open(url) {
      const win = window.open(url);
      if (!win) {
        this.$store.commit('setError', {type:'warning',message:`Your browser permissions must allow pop-up windows`});
        return;
      }
    },
    async deliver(shipment, delivered) {
      this.loading = true;
      const results = await this.$apiCall(`mutation SalesShipments($shipmentId:ID!, $delivered:Boolean!) {
                                            shipmentDeliver(shipmentId: $shipmentId, delivered: $delivered) {
                                              delivered
                                            }
                                           }`, {shipmentId:shipment.id, delivered})
      this.loading = false;
      if (!results.error)
        shipment.delivered = results.data.shipmentDeliver.delivered;
      this.getStatus();
    },
    async deliverMultiple(delivered) {
      this.loading = true;
      let success = 0;
      for (const shipment of this.selected) {
        const results = await this.$apiCall(`mutation SalesShipments($shipmentId:ID!, $delivered:Boolean!) {
                                              shipmentDeliver(shipmentId: $shipmentId, delivered: $delivered) {
                                                delivered
                                              }
                                            }`, {shipmentId:shipment.id, delivered}, true)
        if (!results.error) {
          shipment.delivered = results.data.shipmentDeliver.delivered;
          success ++;
        }
      }
      this.loading = false;
      this.$store.commit('setError', {type:'success',message:`${delivered?'Delivered':'Undelivered'} ${success} of ${this.selected.length} shipments`});
      this.getStatus();
    },
    updatePrivateNote(shipment) {
      this.dialogProperties = {item:shipment, operation:'shipmentUpdatePrivateNote'};
      this.dialog = () => import(`@/components/UpdatePrivateNote`);
    },
    print(dialog, shipment) {
      this.shipment = shipment;
      this.dialog = () => import(`@/views/sales/shipments/${dialog}`);
    }
  }
}
</script>